module.exports = __webpack_public_path__ + "static/media/01A.1ccb97fe.png";